import { render, staticRenderFns } from "./PosturasByIdSpecimen.vue?vue&type=template&id=047a4332"
import script from "./PosturasByIdSpecimen.vue?vue&type=script&lang=js"
export * from "./PosturasByIdSpecimen.vue?vue&type=script&lang=js"
import style0 from "./PosturasByIdSpecimen.vue?vue&type=style&index=0&id=047a4332&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports